import { CultureBookmark, CultureConsumption, CultureItem, CultureItemType, CulturePlan, BookmarkStatus, BookDetails, MovieDetails, SeriesSeason, CultureListEntry, CultureListReference } from '../models/culture.model';

export interface CultureItemInput {
  type: CultureItemType;
  title: string;
  source?: string | null;
  externalId?: string | null;
}

export interface CultureConsumptionInput {
  itemId?: number | null;
  seasonId?: number | null;
  startedOn?: string | null;
  finishedOn?: string | null;
  rating?: number | null;
  comment?: string | null;
}

export interface BookmarkInput {
  title: string;
  url: string;
  type: CultureBookmark['type'];
  source: string;
  externalId?: string | null;
  collection?: string | null;
  tags?: string[];
}

export abstract class CultureRepository {
  abstract listItems(): Promise<CultureItem[]>;
  abstract createItem(input: CultureItemInput): Promise<CultureItem>;
  abstract updateItem(id: number, title: string): Promise<void>;
  abstract deleteItem(id: number): Promise<void>;
  abstract getBookDetails(itemId: number): Promise<BookDetails | null>;
  abstract saveBookDetails(details: BookDetails): Promise<void>;
  abstract getMovieDetails(itemId: number): Promise<MovieDetails | null>;
  abstract saveMovieDetails(details: MovieDetails): Promise<void>;
  abstract listSeasons(seriesId: number): Promise<SeriesSeason[]>;
  abstract addSeason(seriesId: number, seasonNumber: number, episodeCount: number | null): Promise<SeriesSeason>;
  abstract listConsumptions(): Promise<CultureConsumption[]>;
  abstract addConsumption(input: CultureConsumptionInput): Promise<CultureConsumption>;
  abstract deleteConsumption(id: number): Promise<void>;
  abstract listPlans(startDate: string, endDate: string): Promise<CulturePlan[]>;
  abstract createPlan(input: Omit<CulturePlan, 'id'>): Promise<CulturePlan>;
  abstract deletePlan(id: number): Promise<void>;
  abstract moveCalendarPlan(id: number,direction: -1 | 1): Promise<void>;
  abstract replanCulturePlan(id: number, date: string, axisId: number | null, position: number): Promise<void>;
  abstract setCalendarPlanCompleted(id: number,completed: boolean): Promise<void>;
  abstract selectDailyRaindrops(date: string, bookmarkIds: number[]): Promise<number>;
  abstract releaseExpiredRaindropPlans(today: string): Promise<number>;
  abstract setPlanAxis(planId: number, axisId: number | null): Promise<void>;
  abstract listListEntries(listId: number): Promise<CultureListEntry[]>;
  abstract addListReference(listId: number, reference: CultureListReference): Promise<void>;
  abstract removeListReference(entryId: number): Promise<void>;
  abstract moveListReference(entryId: number, direction: -1 | 1): Promise<void>;
  abstract listBookmarks(includeDone?: boolean): Promise<CultureBookmark[]>;
  abstract listBookmarksByIds(ids: number[]): Promise<CultureBookmark[]>;
  abstract syncRaindrop(token: string, tag: string): Promise<number>;
  abstract upsertBookmark(input: BookmarkInput): Promise<CultureBookmark>;
  abstract updateBookmark(id: number, input: BookmarkInput): Promise<void>;
  abstract updateBookmarkStatus(id: number, status: BookmarkStatus): Promise<void>;
  abstract deleteBookmark(id: number): Promise<void>;
  abstract deleteRaindropBookmarks(ids: number[]): Promise<number>;
}
